import React from 'react';


class Unauth extends React.Component {
  render() {
    const { alreadyMember, openLoginModal, hideHeaderLoginButton, isAffiliatePage } = this.props;

    return (
      <>
        {!hideHeaderLoginButton && (
          <li className="navbar-login-link ">
            <a
              href=""
              role="button"
              onClick={openLoginModal}
            >
              Log in
            </a>
          </li>
        )}
        {!alreadyMember && !isAffiliatePage && (
          <li className="cta-button pull-right">
            <a
              className="purchase cta-join"
              href="/account/purchase"
            >
              Join Now
            </a>
          </li>
        )}
      </>
    );
  }
}

export default Unauth;
